import appleLogo from '@/components/PlatformIcon/icons/apple.png';
import { PlatformTypes } from '@/types/gql.generated';
import { useAlwaysAvailable } from './availability.lib';
import type { DestinationModule } from './types';

export const appleIcsDestination: DestinationModule = {
  platform: PlatformTypes.AppleIcs,
  behavior: 'copy',
  name: 'Apple',
  addLabel: 'Add to Apple',
  syncKind: 'copy',
  // Apple's mark isn't square; width-fit preserves its aspect ratio.
  icon: { kind: 'image', src: appleLogo, fit: 'width' },
  isPinnable: true,
  persistedByServer: false,
  statusSource: 'localOnly',
  useIsAvailable: useAlwaysAvailable,
  weblink: { urlKey: 'apple' },
};
